<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("payments") }}</div>

    <payment-datatable ref="payment_datatable" />
  </section>
</template>

<script>
import PaymentDatatable from "./payment_datatable/Index.vue";

export default {
  name: "Payment",
  components: {
    PaymentDatatable,
  },
};
</script>
